export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de certificados"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "no_formats": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No tiene formatos asignados"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to certifications list"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrar"])},
          "no_formats": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No formats assigned"])}
        }
      }
    }
  })
}